import { render, staticRenderFns } from "./cookie-modal.vue?vue&type=template&id=3b52c47d&scoped=true&"
import script from "./cookie-modal.vue?vue&type=script&lang=js&"
export * from "./cookie-modal.vue?vue&type=script&lang=js&"
import style0 from "./cookie-modal.vue?vue&type=style&index=0&id=3b52c47d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b52c47d",
  null
  
)

component.options.__file = "cookie-modal.vue"
export default component.exports